import { Component, HostListener, isDevMode, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Event, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { ThemeService } from './service/theme.service';
import { LoadingComponent } from './common/loading/loading.component';
import { OrientationOverlayComponent } from './orientation-overlay/orientation-overlay.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingComponent, OrientationOverlayComponent, RouterOutlet]
})
export class AppComponent implements OnInit {
	title = 'Highfield Core';

	public loading = false;
	public isLandscape: boolean = true;

	constructor(private router: Router,
		private themeService: ThemeService,
		private updates: SwUpdate) {

		if (!isDevMode()) {
			document.oncontextmenu = () => false;
		}

		this.updates.activateUpdate().then(() => document.location.reload());

		this.router.events.subscribe((event: Event) => {
			switch (true) {
				case event instanceof NavigationStart: {
					const navigationEvent: NavigationStart = event as NavigationStart;
					this.loading = true;

					if (navigationEvent.url === '/exam/end' || navigationEvent.url.startsWith('/error')) {
						window.removeEventListener('beforeunload', this.unloadHandler);
					} else if (navigationEvent.url === '/exam') {
						window.addEventListener('beforeunload', this.unloadHandler);
					}
					break;
				}

				case event instanceof NavigationEnd:
				case event instanceof NavigationCancel:
				case event instanceof NavigationError: {
					this.loading = false;
					break;
				}
				default: {
					break;
				}
			}
		});

		this.checkOrientation();
	}

	public ngOnInit(): void {
		this.themeService.init();
	}

	public unloadHandler(e: BeforeUnloadEvent): void {
		e.preventDefault();
		e.returnValue = true;
	}

	@HostListener('window:resize')
	public onResize(): void {
		this.checkOrientation();
	}

	private checkOrientation(): void {
		this.isLandscape = window.matchMedia('(orientation: landscape)').matches;
	}
}
